export default __webpack_public_path__ + "static/media/telephone.8ebb9132.png";